import { type ReactNode } from 'react';
import { usePageCopy } from '../../../hooks/usePageCopy';

interface PageI18nProviderProps {
  children: ReactNode;
}

export default function PageI18nProvider({ children }: PageI18nProviderProps) {
  usePageCopy();
  return <>{children}</>;
}
